<template lang="pug">
  div.page-login

    .widget
      .widget-body
        h1(v-if="!poweredByOvalio") Panel Access
        h1(v-if="poweredByOvalio") OCTAVA
        .logo
          img(alt="Logo", :src="'/assets/'+platformName+'/logo-black.png'", :onerror="fallbackLogo")
        form(@submit.prevent="submit")
          .form-group
            input.form-control(type="email", v-model="email", placeholder="Email")
          .form-group
            password-input(v-model="password", placeholder="Password")
          .alert.alert-danger(v-if="errorText") {{ errorText }}
          .form-group.text-right
            button.btn.btn-sm.btn-primary(type="submit", :disabled="busy")
              | Login
              =' '
              .la(:class="{'la-arrow-right':!busy,'la-spinner la-spin':busy}")
          .form-group.text-center
            router-link(:to="{name:'forgot-password'}") Forgot Password?
</template>
<style lang="scss">
.page-login {
  padding-top: 20vh;
  text-align: center;

  .widget {
    max-width: 460px;
    width: 100%;
    margin: auto;

    h1 {
      font-size: 30px;
      font-weight: 300;
      margin: 0 0 15px 0;
    }
  }

  .logo {
    text-align: center;
    padding: 20px;

    img {
      max-width: 100%;
      max-height: 200px;
    }

    @media (max-width: 767px) {
      padding: 10px 0;

      img {
        max-height: 50px;
      }
    }
  }
}
</style>
<script>
import http, { setAuthToken } from '@/api/http';
import { ovReq } from '@/api/ov-req';

export default {
  data() {
    return {
      errorText: '',
      busy: false,
      email: '',
      password: '',
      platformName: this.$platformName,
      poweredByOvalio: this.$poweredByOvalio,
    };
  },
  computed: {
    fallbackLogo() {
      return 'this.src="/assets/' + this.$platformName + '/logo.png";this.onerror=""';
    },
  },
  methods: {
    submit() {
      if (this.busy) {
        return;
      }
      let data = {
        email: this.email,
        password: this.password,
      };
      this.errorText = '';
      this.busy = true;
      let loginUrl = import.meta.env.VUE_APP_API_BASE_URL + 'api/auth/login';
      http.post(loginUrl, data).then(
        async (response) => {
          const payload = response.data.data;
          setAuthToken(payload.token);
          let settings = {};
          try {
            const config = await ovReq.get('settings/getConfig');
            settings = config.settings || {};
          } catch (e) {
            // no-op: settings are optional on login
          }
          this.$store.dispatch('setUser', {
            ...payload,
            settings,
          });
          this.$router.push('/app');
        },
        (error) => {
          this.busy = false;
          const respData = error && error.response ? error.response.data : null;
          this.errorText = respData && respData.err ? respData.errdesc : 'There has been an error';
        },
      );
    },
  },
};
</script>
